export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?ec82f282c7f54b6370985bdf8406d5b7";